export const installApp = () => {
  if (!window.installPrompt) return;
  window.installPrompt.prompt();
};
